/* eslint-disable no-useless-escape */
import React, { useState } from 'react'
import { InView } from 'react-intersection-observer'
import { gethostPath } from '../../helpers/ContentHelper'
import PromotionPanel from '../PromotionPanel/PromotionPanel'

const FeaturedProducts = () => {
  const [deliveryData, setDeliveryData] = useState()
  const [productsData, setProductsData] = useState()
  const [gettingData, nowGettingData] = useState(false)
  const [hasError, setHasError] = useState(false)

  const featuredProductsData = {
    error: hasError,
    loading: !productsData,
    products: productsData,
    pageBeacon: deliveryData && deliveryData.PageBeacon,
  }

  const fetchProductData = async () => {
    if (!deliveryData?.ProductAd) {
      // If no products, then set empty array
      setProductsData([])
      return
    }
    const featuredSKUs = deliveryData.ProductAd.map((product) => product.ProductSKU)
    Promise.all(featuredSKUs.map((product) => fetch(`${gethostPath()}global-api/products/partNumber=${product}`)))
      .then((groupedResponse) =>
        Promise.all(
          groupedResponse.map((response) =>
            response
              .json()
              .then((dataTest) =>
                dataTest?.data?.data ? { ...dataTest.data.data, included: dataTest.data.included } : null,
              ),
          ),
        ),
      )
      .then((finalData) => {
        const critProds = deliveryData.ProductAd
        const data = []
        finalData.forEach((argosProd, index) => {
          if (!argosProd) return
          data.push({
            ...argosProd,
            attributes: {
              ...{ ...argosProd.attributes },
              ...{ tracking: critProds[index] },
            },
          })
        })
        setProductsData(data)
      })
      .catch((error) => {
        console.error(error)
        setProductsData([])
      })
  }

  const fetchFeaturedProducts = async () => {
    const AMCV_MATCH = /AMCV_[0-9A-Z\%]+AdobeOrg=([0-9a-zA-Z\%\-\_]+)/g.exec(document.cookie)
    const S_VI_MATCH = /s_vi=([0-9a-zA-Z\%\-\|\[\]]+)/g.exec(document.cookie)
    const matchMedia = global.window && window.matchMedia
    const USER_ID = S_VI_MATCH ? S_VI_MATCH[1] : AMCV_MATCH ? AMCV_MATCH[1] : null
    const SUITE = matchMedia('only screen and (max-width: 700px)').matches ? 'mobile' : 'web'

    const URL =
      `${gethostPath()}global-api/homepage/products/api/taxonomy` +
      `?hlpt=H` +
      `&puserid=${USER_ID}` +
      `&platform=${SUITE}` +
      `&creative=150x150_M-C-OG_TI-1_4_Home` +
      `&taxonomy=home` +
      `&minmes=4&maxmes=16` +
      '&apiKey=D3B53863-2511-4DCE-9CD6-DE1F7C02201A' +
      '&beacon=individual' +
      '&verbosity=min'

    const fetchDeliveryData = async () => {
      try {
        const res = await fetch(URL)
        const resData = await res.json()
        setDeliveryData(resData)
      } catch (err) {
        setHasError(true)
      }
    }
    fetchDeliveryData()
  }

  const getData = () => {
    if (!gettingData) {
      nowGettingData(true)
      fetchFeaturedProducts()
    }
  }

  // Fetch product data once delivery data is populated
  deliveryData && typeof productsData === 'undefined' && fetchProductData()

  const title = !deliveryData ? '' : "We think you'll like..."

  const tracking = {
    pageCategory: 'HP',
    mvts: deliveryData?.meta?.mvts[0]?.variantId,
    onLoad: {
      eventName: 'hp_recommendationsLoaded',
      eventAction: 'Recommendations Loaded',
    },
    onView: {
      eventName: 'hp_recommendationsViewed',
      eventAction: 'Recommendations Viewed',
    },
    onSlideChange: {
      eventName: 'hp_recommendationsNewPageViewed',
      eventAction: 'Recommendations New Page Viewed',
    },
  }

  return (
    <InView onChange={(inView) => inView && !deliveryData && getData()}>
      <PromotionPanel
        data={featuredProductsData}
        dataTest='we-think-youll-like'
        tracking={tracking}
        title={title}
        source='monetisation'
        section='middleSlider'
      />
    </InView>
  )
}

export default FeaturedProducts
